/**
 * Lightweight in-memory store for the authenticated user's timezone ID.
 *
 * Populated once after the BFF /api/users/details response is received
 * (dispatched via setUserInfo in userSlice) and then read by the axios
 * request interceptor to attach the `X-TimeZone` header to every outgoing
 * API call. Mirrors the agencyStorage / userIdStorage pattern.
 */
let _timeZoneId: string | null = null;

export const timeZoneStorage = {
  set(timeZoneId: string): void {
    _timeZoneId = timeZoneId;
  },
  get(): string | null {
    return _timeZoneId;
  },
  clear(): void {
    _timeZoneId = null;
  },
};